import { ActionTypes } from '../../constants/ActionTypes';
import { IUserConfigReducer } from '../../interfaces/UserConfig';

const INIT_STATE: IUserConfigReducer = {
  pwaUserConfig: {
    pwaTheme: '',
    lang: '',
  },
  waiteToSet: false,
  getThemeColor: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_PWA_USER_CONFIG: {
      return {
        ...state,
        getThemeColor: true,
      };
    }

    case ActionTypes.FETCH_PWA_USER_CONFIG_SUCCESS: {
      const lang = action.payload.lang ? action.payload.lang : 'fa-IR';
      const pwaTheme = action.payload.pwaTheme
        ? action.payload.pwaTheme
        : 'blue';
      localStorage.setItem('pwaTheme', pwaTheme);
      localStorage.setItem('language', lang);

      return {
        ...state,
        pwaUserConfig: {
          lang,
          pwaTheme,
        },
      };
    }

    case ActionTypes.SET_USER_CONFIG: {
      return {
        ...state,
        pwaUserConfig: action.payload,
        waiteToSet: true,
      };
    }

    case ActionTypes.SET_USER_CONFIG_SUCCESS: {
      return {
        ...state,
        waiteToSet: false,
      };
    }
    default:
      return state;
  }
};
